import React from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css"; // import default styles
import classes from "./ContactDetails.module.css";
import { FormData } from "../utils";
import { AddressForm } from "./AddressForm";
import { t } from "i18next";

type Props = {
  form: FormData;
  setForm: (form: FormData) => void;
  errors: { [key: string]: string };
  isUserForm?: boolean;
};

export const ContactDetails: React.FC<Props> = ({
  form,
  setForm,
  errors,
  isUserForm,
}) => {
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    if (name in form.address) {
      setForm({
        ...form,
        address: { ...form.address, [name]: value },
      });
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handlePhoneChange = (value: string | undefined) => {
    setForm({ ...form, phone: value || "" });
  };

  return (
    <div className={classes.combined_form}>
      {/* User Details */}
      {!isUserForm && (
        <div className={classes.form_group}>
          <label htmlFor="dealerName">{t("form.provider_name")}*</label>
          <input
            id="dealerName"
            name="dealerName"
            type="text"
            value={form.dealerName}
            onChange={handleChange}
            placeholder={t("form.provider_name_placeholder")}
          />
          {errors.dealerName && (
            <div className={classes.error}>{errors.dealerName}</div>
          )}
        </div>
      )}

      <div className={classes.form_group}>
        <label htmlFor="firstName">{t("form.first_name")}*</label>
        <input
          id="firstName"
          name="firstName"
          type="text"
          value={form.firstName}
          onChange={handleChange}
          placeholder={t("form.first_name_placeholder")}
        />
        {errors.firstName && (
          <div className={classes.error}>{errors.firstName}</div>
        )}
      </div>

      <div className={classes.form_group}>
        <label htmlFor="lastName">{t("form.last_name")}*</label>
        <input
          id="lastName"
          name="lastName"
          type="text"
          value={form.lastName}
          onChange={handleChange}
          placeholder={t("form.last_name_placeholder")}
        />
        {errors.lastName && (
          <div className={classes.error}>{errors.lastName}</div>
        )}
      </div>

      {/* Phone number with country dropdown */}
      <div className={classes.form_group}>
        <label htmlFor="phone">{t("form.phone")}*</label>
        <PhoneInput
          id="phone"
          placeholder={t("form.phone_placeholder")}
          defaultCountry="US"
          value={form.phone}
          onChange={handlePhoneChange}
        />
        {errors.phone && <div className={classes.error}>{errors.phone}</div>}
      </div>

      <div className={classes.form_group}>
        <label htmlFor="email">{t("form.email")}*</label>
        <input
          id="email"
          name="email"
          type="email"
          value={form.email}
          onChange={handleChange}
          placeholder={t("form.email_placeholder")}
        />
        {errors.email && <div className={classes.error}>{errors.email}</div>}
      </div>

      {isUserForm && (
        <div className={classes.form_group}>
          <label htmlFor="dealerName">{t("form.provider_name")}*</label>
          <input
            id="dealerName"
            name="dealerName"
            type="text"
            value={form.dealerName}
            onChange={handleChange}
            placeholder={t("form.provider_name_placeholder")}
          />
          {errors.dealerName && (
            <div className={classes.error}>{errors.dealerName}</div>
          )}
        </div>
      )}

      <AddressForm
        address={form.address}
        handleChange={handleChange}
        errors={errors}
      />

      <div className={classes.form_group}>
        <label className={classes.radio_group_title} htmlFor="preferredContact">
          {t("form.preferred_contact_method")}
        </label>
        <select
          id="preferredContact"
          name="preferredContact"
          value={form.preferredContact}
          onChange={handleChange}
        >
          <option value="">{t("form.select_contact_method")}</option>
          <option value="phone">{t("form.phone")}</option>
          <option value="email">{t("form.email")}</option>
        </select>
        {errors.preferredContact && (
          <div className={classes.error}>{errors.preferredContact}</div>
        )}
      </div>
    </div>
  );
};
